import { BrowserRouter } from "react-router-dom";

import { AppInitializer } from "@/app/AppInitializer";
import { AppProviders } from "@/app/AppProviders";
import { InAppBlocker } from "@/app/InAppBlocker";
import { MaintenanceBlocker } from "@/app/MaintenanceBlocker";
import { ModalsContainer } from "@/app/ModalsContainer/index";
import { useIndexedDBFocus } from "@/hooks/useIndexedDBFocus";
import { useOpenReplay } from "@/hooks/useOpenReplay";
import { usePhotoUploadRetry } from "@/hooks/usePhotoUploadRetry";
import { useReminder } from "@/hooks/useReminder";
import { useRequestQueue } from "@/hooks/useRequestQueue";
import { useSaveStoreToServer } from "@/hooks/useSaveStoreToServer";
import Pages from "@/routes/Pages";
import OfflineMode from "@/Services/OfflineMode";

function App() {
    useIndexedDBFocus();
    useRequestQueue();
    usePhotoUploadRetry();
    useSaveStoreToServer();
    useReminder();

    useOpenReplay();

    return (
        <AppProviders>
            <InAppBlocker>
                <MaintenanceBlocker>
                    <AppInitializer />

                    <BrowserRouter>
                        <Pages />
                        <ModalsContainer />
                    </BrowserRouter>

                    <OfflineMode />
                </MaintenanceBlocker>
            </InAppBlocker>
        </AppProviders>
    );
}

export default App;
